/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Excluded_SinceInputs */

const en_us2_profile_excluded_since = /** @type {(inputs: Profile_Excluded_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`out since ${i?.date}`)
};

const pt_br2_profile_excluded_since = /** @type {(inputs: Profile_Excluded_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`fora desde ${i?.date}`)
};

const es_419_profile_excluded_since = /** @type {(inputs: Profile_Excluded_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`fuera desde el ${i?.date}`)
};

const pt_pt2_profile_excluded_since = /** @type {(inputs: Profile_Excluded_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`fora desde ${i?.date}`)
};

const fr_fr2_profile_excluded_since = /** @type {(inputs: Profile_Excluded_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`exclu depuis le ${i?.date}`)
};

const de_de2_profile_excluded_since = /** @type {(inputs: Profile_Excluded_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`raus seit ${i?.date}`)
};

const it_it2_profile_excluded_since = /** @type {(inputs: Profile_Excluded_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`escluso dal ${i?.date}`)
};

/**
* | output |
* | --- |
* | "out since {date}" |
*
* @param {Profile_Excluded_SinceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_excluded_since = /** @type {((inputs: Profile_Excluded_SinceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Excluded_SinceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_excluded_since(inputs)
	if (locale === "es-419") return es_419_profile_excluded_since(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_excluded_since(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_excluded_since(inputs)
	if (locale === "de-DE") return de_de2_profile_excluded_since(inputs)
	if (locale === "it-IT") return it_it2_profile_excluded_since(inputs)
	return en_us2_profile_excluded_since(inputs)
});
export { profile_excluded_since as "profile.excluded_since" }